import { useFetchers } from '@remix-run/react'
import { type NodeViewProps } from '@tiptap/core'
import { NodeViewContent, NodeViewWrapper } from '@tiptap/react'
import { MailCheck, MailX } from 'lucide-react'
import { useEffect, useRef, useState } from 'react'
import { Input } from '#app/components/ui/input.js'
import { StatusButton } from '#app/components/ui/status-button.js'
import { FORM_KEY } from '#app/routes/_public+/$url.($referrer).js'

export const Component = (props: NodeViewProps) => {
	const { editor } = props
	const editable = editor.isEditable
	const { placeholder, redirectUrl, redirect, state, successText } =
		props.node.attrs

	const fetcher = useFetchers().find(f => f.key === FORM_KEY)

	const loading = fetcher?.state && fetcher?.state !== 'idle'
	const $form = useRef<HTMLFormElement>(null)
	const [emailError, setEmailError] = useState(fetcher?.data?.error)

	useEffect(() => {
		if (fetcher?.data && !fetcher?.data.error && redirect) {
			window.parent.location.href = redirectUrl
		}
	}, [fetcher?.data])

	useEffect(() => {
		if (fetcher?.data?.error) {
			$form.current?.reset()
		}
		setEmailError(fetcher?.data?.error)
		$form.current?.focus()
		$form.current?.reset()
	}, [fetcher?.data?.error])

	if (editable) {
		return (
			<NodeViewWrapper>
				<div className="flex w-[420px] max-w-full flex-col">
					<div className="relative">
						<Input
							className="input-tt relative flex !h-[53px] w-full appearance-none"
							type="text"
							defaultValue={placeholder}
							onChange={e =>
								props.updateAttributes({ placeholder: e.currentTarget.value })
							}
						/>
						{state === 'Idle' && (
							<div className="button-tt radius-inner-tt absolute inset-y-1 right-1 flex !h-[45px] w-fit shrink-0 items-center justify-center px-4 text-sm outline-none transition-colors duration-150 ease-in-out disabled:pointer-events-none disabled:opacity-50">
								<NodeViewContent />
							</div>
						)}
						{state === 'Success' && (
							<div className="button-tt radius-inner-tt absolute inset-y-1 right-1 flex !h-[45px] w-fit shrink-0 items-center justify-center px-4 text-sm outline-none transition-colors duration-150 ease-in-out disabled:pointer-events-none disabled:opacity-50">
								<input
									type="text"
									className="w-full appearance-none border-none bg-transparent text-center outline-none"
									defaultValue={successText}
									onChange={e =>
										props.updateAttributes({
											successText: e.currentTarget.value,
										})
									}
								/>
							</div>
						)}
					</div>
				</div>
			</NodeViewWrapper>
		)
	} else {
		return (
			<NodeViewWrapper>
				<div className="w-[420px] max-w-full">
					<div
						className={`flex w-full flex-col transition-all duration-100 ease-in-out`}
					>
						<div className="relative">
							<Input
								className="input-tt relative flex !h-[53px] w-full appearance-none"
								type="email"
								name="email"
								placeholder={placeholder}
								noIcon
								required
								onFocus={() => {
									setEmailError(undefined)
								}}
							/>
							<StatusButton
								type="submit"
								variant="customizer"
								status={loading ? 'pending' : 'idle'}
								disabled={fetcher?.data && !redirect}
								className="button-tt radius-inner-tt absolute inset-y-1 right-1 flex !h-[45px] w-fit shrink-0 items-center justify-center px-4 text-sm outline-none transition-colors duration-150 ease-in-out disabled:pointer-events-none"
							>
								{fetcher?.data && !redirect ? (
									emailError ? (
										<>
											<MailX className="tt-submit-icon" width={16} />{' '}
											{emailError}
										</>
									) : (
										<>
											<MailCheck className="tt-submit-icon" width={16} />{' '}
											{successText}
										</>
									)
								) : (
									<NodeViewContent />
								)}
							</StatusButton>
						</div>
					</div>
				</div>
			</NodeViewWrapper>
		)
	}
}

export default Component
